import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'

import * as pdp from '../../../store/productDetailPage'

import {closeSoldOutModal} from '../../../actions/productDetailPage'

function SoldOutModalCta(props) {
  const displayCategory = props.displayedProduct.set_specs.default_display_category_name
  const categoryUrl = `/collection/${props.displayedProduct.set_specs.default_display_category_slug}`
  return (
    <Link className="modal-cta" onClick={props.closeSoldOutModal} to={categoryUrl}>
      Browse {displayCategory}
    </Link>
  )
}

SoldOutModalCta.propTypes = {
  displayedProduct: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({})]),
  closeSoldOutModal: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    displayedProduct: pdp.product(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    closeSoldOutModal: () => dispatch(closeSoldOutModal()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SoldOutModalCta)
